import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EditTemplateMenuHeaderComponent } from '../../edit-template-menu-header.component';
import { EditTemplateCardStackMenuViewModel } from '../edit-template-card-stack-menu-view-model';

@Component({
  selector: 'app-edit-template-card-stack-menu-header',
  templateUrl: './edit-template-card-stack-menu-header.component.html',
  styleUrls: [
    './edit-template-card-stack-menu-header.component.scss',
    '../../../../../shared/styles/edit-page-styles.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditTemplateCardStackMenuHeaderComponent extends EditTemplateMenuHeaderComponent {
  constructor(public override viewModel: EditTemplateCardStackMenuViewModel) {
    super(viewModel);
  }
}
